import React, { useState } from 'react';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [countryCode, setCountryCode] = useState('+420'); // default ČR
  const [phone, setPhone] = useState('');
  const [country, setCountry] = useState('');

  const register = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/register`, {
      method: 'POST',
      body: JSON.stringify({ email, password, name, countryCode, phone }),
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status === 201) {
      alert('Registration successful ✅');
    } else {
      const errMsg = await response.json();
      alert(`Registration failed ❌: ${errMsg.message || 'Unknown error'}`);
    }
  };

  return (
    <form className="register" onSubmit={register}>
      <h1>Register</h1>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Full name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <div
        style={{
          display: 'flex',
          gap: '8px',
          marginTop: '5px',
          border: '1px solid rgb(220, 220, 220)',
          borderRadius: '6px',
          padding: '4px',
          width: '100%',
        }}
      >
        <select value={countryCode} onChange={(e) => setCountryCode(e.target.value)} required>
          <option value="+420">🇨🇿 +420</option>
          <option value="+421">🇸🇰 +421</option>
          <option value="+49">🇩🇪 +49</option>
          <option value="+44">🇬🇧 +44</option>
          <option value="+1">🇺🇸 +1</option>
        </select>

        <input
          type="tel"
          placeholder="Phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </div>
      <input
        type="text"
        placeholder="Country"
        value={country}
        onChange={(e) => setCountry(e.target.value)}
      />
      <button type="submit">Register</button>
    </form>
  );
};

export default RegisterPage;
